/**
 * Created by marcobosso on 26/10/16.
 */
var Helpers = {
    reInitializeSelect2: function (obj, data) {
        var array = $.map(data, function (value, key) {
            return {id: key, text: value};
        });
        obj.html("");
        obj.select2({
            data: array
        });
    },
    urlTabbable: function () {
        var url = document.location.toString();
        if (url.match('#')) {
            $('.nav-tabs a[href=#' + url.split('#')[1] + ']').tab('show');
        }

        // Change hash for page-reload
        $('.nav-tabs a').on('shown.bs.tab', function (e) {
            window.location.hash = e.target.hash;
        })
    },
    reInitializeSelect2WithOptions: function (obj, data) {
        var array = [];
        for (key in data) {
            if (key != 0){
                var children = [];
                for (value in data[key]){
                    children.push({
                        id: value,
                        text: data[key][value]
                    })
                }
                array.push({
                    text: key,
                    children: children
                });
            }
        }
        obj.html("");
        obj.select2({
            data: array
        });
    },
    buildErrorMessageList: function (messages) {
        var html = "<ul>";
        for (var i in messages) {
            html += "<li>" + messages[i] + '</li>';
        }
        html += "</ul>";
        return html;
    },
    filtersFor: function (form) {
      var filters = {};
      for (var submitted in form) {
        if (filters[form[submitted].name] == undefined) {
          filters[form[submitted].name] = [];
        }
        filters[form[submitted].name].push(form[submitted]['value']);
      }
      return filters
    },
    checkSelected: function (container, inputName) {
        var filterBy = [];
        $.each($(container + " [name='" + inputName + "']:checked"), function () {
            filterBy.push($(this).val());
        });
        return filterBy;
    },
    checkSelectedAndRemove: function (filtersId) {
        var names = this.buildArrayInputs($(filtersId + ' input[name][id][value]'));
        for(var i = 0; i < names.length; i++) {
            var filterBy = this.checkSelected(filtersId, names[i]);
            if ($("input[name='" + names[i] + "']:checked").length != 0 && $("input[name='" + names[i] + "']:checked").length != $("input[name='" + names[i]+"']").length) {
                var value = filterBy.toString().replace(new RegExp(',', 'g'), '-');
                $(filtersId).append('<input type="text" class="hidden" name="' + names[i] + '" value="' + value + '"/>');
            }
            $(filtersId + " input[name='" + names[i]+ "']").remove();
        }
        
    },
    buildArrayInputs: function (inputList) {
        var inputs = [];
        $(inputList).each(function () {
            if (!inputs.includes($(this).attr('name'))) {
                inputs.push($(this).attr('name'));
            }
        });
        return inputs;
    },
    handlePreviewMail: function (previewUrl, sendUrl) {
        $('#mailPreviewModal').modal();
        $("#mailPreviewIframe").attr("src", previewUrl);
        $('#sendMail').on('click', function () {
            window.location = sendUrl;
        });
    },

    getWidgetFilters: function (widget) {
        var filters = {};
        if($('#' + widget + '-filters').length > 0){
            var names = Helpers.buildArrayInputs($('#' + widget + '-filters input[name][id][value]'));
            for(var i = 0; i < names.length; i++) {
                filters[names[i]] = Helpers.checkSelected('#' + widget + '-filters', names[i]).toString().replace(new RegExp(',', 'g'), '-');
            }
        }
        return filters;
    }

};
